/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ProjectTypeRequest,
  ProjectTypeResponse,
  V1ProjectTypesListError,
  V1ProjectTypesUpdateError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class ProjectType<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags ProjectType
   * @name V1ProjectTypesList
   * @request GET:/api/v1/project-types
   * @secure
   * @response `200` `(ProjectTypeResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1ProjectTypesList = (
    query?: {
      onlyWithSelectableModel?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectTypeResponse[], V1ProjectTypesListError>({
      path: `/api/v1/project-types`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ProjectType
   * @name V1ProjectTypesUpdate
   * @summary Updates (if Id is set), creates (if Id is not set) and deletes (exists in DB but not in request and is unused) project types.
   * @request PUT:/api/v1/project-types
   * @secure
   * @response `200` `(ProjectTypeResponse)[]` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1ProjectTypesUpdate = (data: ProjectTypeRequest[], params: RequestParams = {}) =>
    this.http.request<ProjectTypeResponse[], V1ProjectTypesUpdateError>({
      path: `/api/v1/project-types`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
